import React from "react";
import "../Tabels/Tabels.css";

import Header from "../Header/Header";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faWarehouse, fas } from "@fortawesome/free-solid-svg-icons";

import FundManage from "./FundManage";
import UserWiseReport from "./UserWiseReport";
library.add(fas);

// *****************************************************************************************************

const Tables = () => {
  

  return (
    <>
      <div className="main-advancedashboard">
        <div className="investor">
          <Header
            icon={faWarehouse}
            title={"Reports List"}
            link={"/payment/inward-payment"}
          />
         <FundManage />
         <UserWiseReport />
        </div>
      </div>
    </>
  );
};

export default Tables;
